// Copyright (c) StrangeBee 2024

export const ListItemsPerPage = [10, 30, 50, 100, 150, 300] as const;

export type ListItemsPerPageType = (typeof ListItemsPerPage)[number];

export enum PageDirection {
    PREVIOUS = -1,
    NEXT = 1,
}
